/* Request to Order modal - see snippets/request-to-order.liquid and rto-worker/ */
(function () {
    var DEFAULT_MAX = 25;

    function clampQty (value, max) {
        var cap = Number(max) > 0 ? Number(max) : DEFAULT_MAX;
        var n = parseInt(value, 10);
        if (isNaN(n) || n < 1) return 1;
        return Math.min(n, cap);
    }

    // Shopper-facing text for each worker answer. The worker only returns fixed codes.
    function messageFor (status, code, contact) {
        var mail = contact ? ' or email us at ' + contact : '';
        if (status === 429) return 'You have sent a few requests already. Please try again later' + mail + '.';
        if (status === 403) return 'We could not verify the request. Please complete the check below and try again.';
        if (status === 400 && code === 'not_available') {
            return 'This product cannot be requested online right now.' + (contact ? ' Please email us at ' + contact + '.' : '');
        }
        if (status === 400) return 'Please check your email address and quantity, then try again.';
        return 'We could not send your request. Please try again in a few minutes' + mail + '.';
    }

    function newRequestId () {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
        var b = new Uint8Array(16);
        crypto.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        var h = Array.prototype.map.call(b, function (x) { return (x + 0x100).toString(16).slice(1); }).join('');
        return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
    }

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = { clampQty: clampQty, messageFor: messageFor, newRequestId: newRequestId };
        return;
    }

    // Cloudflare Turnstile, loaded once and only when a dialog reaches the review step.
    var turnstileReady = null;
    function loadTurnstile () {
        if (turnstileReady) return turnstileReady;
        turnstileReady = new Promise(function (resolve, reject) {
            if (window.turnstile) return resolve(window.turnstile);
            var s = document.createElement('script');
            s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            s.async = true;
            s.onload = function () { resolve(window.turnstile); };
            s.onerror = function () { turnstileReady = null; reject(new Error('turnstile load')); };
            document.head.appendChild(s);
        });
        return turnstileReady;
    }

    function init (wrap) {
        var dialog = wrap.querySelector('.rto-dialog');
        var data = JSON.parse(wrap.querySelector('[data-rto-data]').textContent);
        var form = wrap.closest('form');
        var $ = function (sel) { return dialog.querySelector(sel); };
        var qtyInput = $('[name="rto_qty"]');
        var emailInput = $('[name="rto_email"]');
        var msgInput = $('[name="rto_message"]');
        var hpInput = $('[name="company_website"]');
        var tsBox = $('[data-rto-turnstile]');
        var endpoint = wrap.dataset.rtoEndpoint || '/apps/ebc/request-to-order';
        var contact = wrap.dataset.rtoContact || '';
        var siteKey = wrap.dataset.rtoSitekey || '';
        var maxQty = wrap.dataset.rtoMax || DEFAULT_MAX;
        var step = 1;
        var variant = data.variants[0];
        var requestId = newRequestId();
        var tsWidget = null;
        var tsToken = '';

        function currentVariant () {
            var idInput = form && form.querySelector('[name="id"]');
            var id = idInput ? Number(idInput.value) : null;
            return data.variants.find(function (v) { return v.id === id; }) || data.variants[0];
        }

        function showError (message) {
            dialog.querySelectorAll('.rto-error').forEach(function (el) {
                el.textContent = message || '';
                el.hidden = !message;
            });
        }

        function renderProduct () {
            var qty = clampQty(qtyInput.value, maxQty);
            var variantTitle = variant.title === 'Default Title' ? '' : variant.title;
            $('.rto-img').hidden = !variant.image; // products without a photo
            if (variant.image) $('.rto-img').src = variant.image;
            $('.rto-img').alt = data.title;
            $('.rto-name').textContent = data.title;
            $('.rto-variant').textContent = variantTitle;
            $('.rto-r-product').textContent = data.title + (variantTitle ? ' - ' + variantTitle : '');
            $('.rto-r-qty').textContent = qty;
            $('.rto-r-email').textContent = emailInput.value.trim();
            $('.rto-r-msg').textContent = msgInput.value.trim() || 'No message';
        }

        function resetTurnstile () {
            tsToken = '';
            if (tsWidget !== null && window.turnstile) window.turnstile.reset(tsWidget);
        }

        function showTurnstile () {
            if (!siteKey || !tsBox) return;
            loadTurnstile().then(function (ts) {
                if (tsWidget !== null) return;
                tsWidget = ts.render(tsBox, {
                    sitekey: siteKey,
                    action: 'request_to_order',
                    callback: function (token) { tsToken = token; }, // keep any error on screen: a reset re-issues a token
                    'expired-callback': function () { tsToken = ''; },
                    'error-callback': function () {
                        tsToken = '';
                        showError('The security check could not load. Please refresh the page' + (contact ? ' or email us at ' + contact : '') + '.');
                    }
                });
            }).catch(function () {
                showError(messageFor(503, '', contact));
            });
        }

        function go (next) {
            step = next;
            showError('');
            dialog.querySelectorAll('.rto-step').forEach(function (s) { s.hidden = s.dataset.step !== String(next); });
            dialog.querySelectorAll('.rto-steps li').forEach(function (li, i) { li.classList.toggle('is-active', i < next || next === 'done'); });
            renderProduct();
            if (next === 3) showTurnstile();
        }

        function next () {
            if (step === 1) {
                qtyInput.value = clampQty(qtyInput.value, maxQty);
                go(2);
                if (!emailInput.readOnly) emailInput.focus();
            } else if (step === 2) {
                if (!emailInput.checkValidity() || !emailInput.value.trim()) {
                    showError('Please enter a valid email address.');
                    emailInput.focus();
                    return;
                }
                go(3);
            }
        }

        // Posts through the Shopify app proxy (same origin) to rto-worker/.
        function submit (button) {
            if (siteKey && !tsToken) {
                showError(window.turnstile ? 'Please tick the "Verify you are human" box above first.' : 'The security check could not load. Please refresh the page' + (contact ? ' or email us at ' + contact : '') + '.');
                return;
            }
            button.disabled = true;
            showError('');
            fetch(endpoint, {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    requestId: requestId,
                    email: emailInput.value.trim(),
                    variantId: String(variant.id),
                    quantity: clampQty(qtyInput.value, maxQty),
                    message: msgInput.value.trim(),
                    turnstileToken: tsToken,
                    company_website: hpInput ? hpInput.value : ''
                })
            })
                .then(function (res) {
                    return res.json().catch(function () { return {}; }).then(function (body) {
                        if (res.ok && body && body.ok) {
                            requestId = newRequestId(); // the next request is a new one
                            resetTurnstile();
                            go('done');
                            return;
                        }
                        resetTurnstile(); // Turnstile tokens are single use
                        showError(messageFor(res.status, body && body.error, contact));
                    });
                })
                .catch(function () {
                    resetTurnstile();
                    showError(messageFor(0, '', contact));
                })
                .finally(function () { button.disabled = false; });
        }

        dialog.addEventListener('click', function (e) {
            if (e.target === dialog || e.target.closest('[data-rto-close]')) return dialog.close();
            var qtyBtn = e.target.closest('[data-rto-qty]');
            if (qtyBtn) {
                qtyInput.value = clampQty(Number(qtyInput.value) + Number(qtyBtn.dataset.rtoQty), maxQty);
                return renderProduct();
            }
            if (e.target.closest('[data-rto-next]')) return next();
            if (e.target.closest('[data-rto-back]')) return go(step - 1);
            var submitBtn = e.target.closest('[data-rto-submit]');
            if (submitBtn) submit(submitBtn);
        });

        qtyInput.addEventListener('input', renderProduct);

        // The dialog sits inside the product <form>: stop Enter from submitting it (add to cart).
        dialog.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
                e.preventDefault();
                next();
            }
        });

        wrap.rtoOpen = function () {
            variant = currentVariant();
            go(1);
            dialog.showModal();
        };
    }

    document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-rto-open]');
        if (!opener) return;
        var wrap = opener.closest('[data-rto-wrap]');
        if (!wrap) return;
        e.preventDefault();
        if (!wrap.rtoOpen) init(wrap);
        wrap.rtoOpen();
    });
})();
